<template>
  <v-container fluid tag="section" class="text_google">
    <base-material-card
      color="warning"
      icon="mdi-account-switch"
      title="สวมสิทธิ์ผู้ใช้งาน (Switch User)"
      class="px-5 py-3"
    >
      <v-alert type="warning" outlined dense class="mb-4">
        เครื่องมือนี้สำหรับแอดมินส่วนกลางเข้าใช้งานแทนบัญชีอื่นเพื่อช่วยเหลือ/ตรวจสอบปัญหาเท่านั้น
        ทุกครั้งที่กดสวมสิทธิ์จะถูกบันทึกลงประวัติ ดูได้ที่หน้า "ตรวจสอบความปลอดภัยระบบ"
        (เฉพาะ SuperAdmin)
      </v-alert>

      <v-row>
        <v-col cols="12" md="4">
          <v-select
            v-model="accountType"
            :items="accountTypeOptions"
            item-text="text"
            item-value="value"
            label="ประเภทบัญชี"
            outlined
            dense
            @change="onAccountTypeChange"
          ></v-select>
        </v-col>

        <template v-if="accountType === 'user'">
          <v-col cols="12" md="4">
            <v-select
              v-model="search.user_status"
              :items="userStatusOptions"
              item-text="text"
              item-value="value"
              label="สถานะบัญชี (A/B/C/G/S)"
              outlined
              dense
            ></v-select>
          </v-col>
        </template>

        <template v-else>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search.college_code"
              label="รหัสวิทยาลัย/หน่วยงาน"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search.id_card"
              label="เลขบัตรประชาชน (ค้นหาเฉพาะบุคคล)"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </template>

        <v-col cols="12" md="4" class="d-flex align-center">
          <v-btn color="primary" :loading="loading" @click="doSearch">
            <v-icon left small>mdi-magnify</v-icon>ค้นหา
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        no-data-text="ยังไม่มีผลการค้นหา — เลือกประเภทบัญชีและกดค้นหา"
      >
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="deep-orange"
            dark
            @click="
              startImpersonation({
                subjectType: accountType,
                subjectId: item._subjectId,
                displayName: item._displayName,
              })
            "
          >
            <v-icon left small>mdi-login-variant</v-icon>เข้าใช้งานแทน
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { impersonationMixin } from "@/mixins/impersonation";

export default {
  name: "SwitchUser",
  mixins: [impersonationMixin],
  data() {
    return {
      ApiKey: "HRvec2021",
      accountType: "user",
      accountTypeOptions: [
        { value: "user", text: "หน่วยงาน (A/B/C/G/S)" },
        { value: "personnel_temporary", text: "ข้าราชการครู/บุคลากรทางการศึกษา" },
        { value: "personnel_etc", text: "พนักงานราชการ/ลูกจ้าง" },
        { value: "assistantteach", text: "ครูผู้ช่วย" },
      ],
      userStatusOptions: [
        { value: "A", text: "A - ผู้ดูแลระบบ" },
        { value: "B", text: "B - สถานศึกษา" },
        { value: "C", text: "C - สถาบันการอาชีวศึกษา" },
        { value: "G", text: "G - อาชีวศึกษาจังหวัด" },
        { value: "S", text: "S - ศึกษานิเทศก์/หน่วยตรวจราชการ" },
      ],
      search: {
        user_status: "B",
        college_code: "",
        id_card: "",
      },
      loading: false,
      results: [],
    };
  },
  computed: {
    headers() {
      return [
        { text: "ชื่อ-นามสกุล", value: "_displayName" },
        { text: "เลขที่/รหัส", value: "_subjectId" },
        { text: "หน่วยงาน/วิทยาลัย", value: "_agency" },
        { text: "", value: "action", sortable: false, align: "end" },
      ];
    },
  },
  methods: {
    onAccountTypeChange() {
      this.results = [];
    },
    // endpoint เดิมของแต่ละตารางคืนรูปแบบไม่เหมือนกัน (บางเงื่อนไข fetch แถวเดียว บางเงื่อนไข
    // fetchAll) — ทำให้เป็น array เสมอที่นี่ แทนที่จะไปไล่แก้ endpoint เดิมที่มีอยู่ก่อนจำนวนมาก
    normalizeToArray(data) {
      if (!data) return [];
      if (Array.isArray(data)) return data;
      if (typeof data === "object" && Object.keys(data).length) return [data];
      return [];
    },
    async doSearch() {
      this.loading = true;
      this.results = [];
      try {
        if (this.accountType === "user") {
          const result = await this.$http.post("user.php", {
            ApiKey: this.ApiKey,
            user_status: this.search.user_status,
          });
          this.results = this.normalizeToArray(result.data).map((row) => ({
            ...row,
            _subjectId: row.user_ID,
            _displayName: `${row.user_name} — ${row.user_firstname || ""} ${row.user_lastname || ""}`.trim(),
            _agency: row.college_name || row.user_code || "-",
          }));
        } else if (this.accountType === "personnel_temporary") {
          const payload = { ApiKey: this.ApiKey };
          if (this.search.id_card) payload.id_cards = this.search.id_card;
          else if (this.search.college_code) payload.college_code = this.search.college_code;
          else {
            this.loading = false;
            return;
          }
          const result = await this.$http.post("personnel_temporary.php", payload);
          this.results = this.normalizeToArray(result.data).map((row) => ({
            ...row,
            _subjectId: row.id_card,
            _displayName: `${row.title_s || ""}${row.frist_name || ""} ${row.last_name || ""}`.trim(),
            _agency: row.college_name || row.college_code || "-",
          }));
        } else if (this.accountType === "personnel_etc") {
          const payload = { ApiKey: this.ApiKey };
          if (this.search.id_card) payload.personnel_etc_id_card = this.search.id_card;
          else if (this.search.college_code) payload.personnel_etc_college_code = this.search.college_code;
          else {
            this.loading = false;
            return;
          }
          const result = await this.$http.post("personnel_etc.php", payload);
          this.results = this.normalizeToArray(result.data).map((row) => ({
            ...row,
            _subjectId: row.personnel_etc_id_card,
            _displayName: `${row.personnel_etc_fristname || ""} ${row.personnel_etc_lastname || ""}`.trim(),
            _agency: row.college_name || row.personnel_etc_college_code || "-",
          }));
        } else if (this.accountType === "assistantteach") {
          const payload = { ApiKey: this.ApiKey };
          if (this.search.id_card) payload.idCard = this.search.id_card;
          else if (this.search.college_code) payload.assistantCollege = this.search.college_code;
          else {
            this.loading = false;
            return;
          }
          const result = await this.$http.post("assistantteach.php", payload);
          this.results = this.normalizeToArray(result.data).map((row) => ({
            ...row,
            _subjectId: row.idCard,
            _displayName: row.NameFL || "-",
            _agency: row.college_name || row.assistantCollege || "-",
          }));
        }
      } catch (error) {
        console.error("switch_user doSearch error:", error);
        Swal.fire({
          icon: "error",
          title: "ค้นหาไม่สำเร็จ กรุณาลองใหม่",
          showConfirmButton: false,
          timer: 1500,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.text_google {
  font-family: "Kanit", sans-serif;
}
</style>
